// product info
const product = JSON.parse(document.querySelector("#product-info").innerHTML);

// check if the add to cart is disabled 

if (window.isDisableAtc) {
    const isMicroModalInit = setInterval(() => {
        if (window.MicroModal != undefined) {
            clearInterval(isMicroModalInit);
            window.MicroModal.show("platform-limit-modal");
        }
    }, 100);
}

// Product Thumbnail JS

const productMainCarousel = document.querySelector(".it-product--media-gallery");
const productThumbnails = document.querySelectorAll(".it-product--media-gallery-thumbnails li");

// initialize Flickity slider
const isFlicktiyInit = setInterval(() => {
    if (window.Flickity != undefined) {
        clearInterval(window.Flickity);
        flickityInit();
    }
}, 100);
function flickityInit() {
    const productMainCarouselFlkt = new Flickity(productMainCarousel, { 
        "contain": true, 
        "pageDots": false 
    });

    // galllery thumbnail function
    productThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", () => {
            productThumbnails.forEach(el => el.classList.remove("active"));
            thumbnail.classList.add("active");
            productMainCarouselFlkt.select(index);
        });
    });

    // flickity select funciton

    productMainCarouselFlkt.on("change", (index) => {
        productThumbnails.forEach(el => el.classList.remove("active"));
        productThumbnails[index].classList.add("active");
    });
}

// Product Price Update
function productPriceUpdate() {
    const current_variant_id = document.querySelector(".it-product--form-variants")[document.querySelector(".it-product--form-variants").selectedIndex].value;
    const product_price_selector = document.querySelector(".it-product--price .price");
    const product_compare_price_selector = document.querySelector(".it-product--price .compare-price");
    let current_variant_price = 0;
    let current_variant_compare_price = 0;

    product.variants.forEach((variant) => {
        if (variant.id == current_variant_id) {
            current_variant_price = variant.price;
            if (variant.compare_at_price) {
                current_variant_compare_price = variant.compare_at_price;
            }
        }
    });

    if (product_price_selector.hasAttribute("data-product-quantity")) {
        current_variant_price = current_variant_price * parseInt(product_price_selector.dataset.productQuantity);
        if (product_compare_price_selector != null && current_variant_compare_price != 0) {
            current_variant_compare_price = current_variant_compare_price * parseInt(product_price_selector.dataset.productQuantity);
        }
    }

    if (product_price_selector.hasAttribute("data-subscription-price")) {
        current_variant_price = current_variant_price + parseInt(product_price_selector.dataset.subscriptionPrice);
        if (product_compare_price_selector != null && current_variant_compare_price != 0) {
            current_variant_compare_price = current_variant_compare_price + parseInt(product_price_selector.dataset.subscriptionPrice);
        }
    }

    product_price_selector.innerText = `$${(current_variant_price / 100).toFixed(2)}`;
    if (product_compare_price_selector != null && current_variant_compare_price != 0) {
        product_compare_price_selector.innerText = `$${(current_variant_compare_price / 100).toFixed(2)}`
    }
}

// Product Location JS

class ProductLocation extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {

        // enable add to cart button
        if (!window.isDisableAtc) {
            document.querySelectorAll(".it-product--actions-button").forEach((el) => el.removeAttribute("disabled"));
        }
        
        const all_countries = document.querySelector("#all_countries");
        const available_countries = this.dataset.availableCountries.split("|");
        const country_select = this.querySelector("select[name='properties[Country]'");
        const province_select = this.querySelector("select[name='properties[Province]'");
        const REMOVE_STATES = ["American Samoa", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific", "Guam", "Marshall Islands", "Northern Mariana Islands", "Palau", "Puerto Rico", "Virgin Islands", "Federated States of Micronesia"];
        let current_country = "United States";
        
        if (country_select && available_countries) {
            let find_country_option = [];
            available_countries.forEach((country) => {
                find_country_option = all_countries.querySelector(
                    "[value='" + country + "']"
                );

                if (find_country_option) {
                    let clone = find_country_option.cloneNode(true);
                    if (clone) {
                        country_select.appendChild(clone);
                        renderOption();
                    }
                }
            });
        }

        if (country_select) {
            country_select.addEventListener("change", function(event) {
                if (event.target.value == "Canada") {

                    // show modal
                    window.MicroModal.show("can-blood-modal");

                    // update current country value
                    current_country = "Canada";

                    // disable blood draw
                    this.closest(".it-product--form").querySelectorAll(".it-product--form-custom-control").forEach((el) => el.classList.remove("selected"));
                    this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Blood draw in lab']").setAttribute("disabled", "disabled");
                    this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Mobile blood draw']").classList.add("selected");

                    // change message
                    document.querySelector(".it-product--message.it-product--blood-draw").classList.add("hide");
                    document.querySelector(".it-product--message.it-product--mbd").classList.remove("hide");

                    // update Variant ID
                    this.closest(".it-product--form").querySelectorAll(".it-product--form-variants option").forEach((opt, index) => {
                        if(opt.text == "Mobile blood draw / No InnerAge / No Estradiol + Progesterone" || opt.text == "Mobile blood draw / InnerAge" || opt.text == "Mobile blood draw") {
                            this.closest(".it-product--form").querySelector(".it-product--form-variants").selectedIndex = index;

                            // update bnpl widget product id
                            document.querySelector(".installment input[name='id']").value = opt.value;
                            document.querySelector('.bnpl__widget input[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));

                            // price update
                            productPriceUpdate();
                        }
                    });


                } else {

                    // enable blood draw
                    this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Blood draw in lab']").removeAttribute("disabled");

                    // update current country value
                    current_country = "United States";

                    // change message
                    document.querySelector(".it-product--message.it-product--blood-draw").classList.remove("hide");
                    document.querySelector(".it-product--message.it-product--mbd").classList.add("hide");
                }

                renderOption();

            });
        }

        if (province_select) {
            province_select.addEventListener("change", function(event) {
                if (current_country == "United States") {
                    if (RESTRICTED_STATES.includes(event.target.value)) {
    
                        // show modal
                        window.MicroModal.show("us-blood-modal");
    
                        // disable blood draw 
                        this.closest(".it-product--form").querySelectorAll(".it-product--form-custom-control").forEach((el) => el.classList.remove("selected"));
                        this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Blood draw in lab']").setAttribute("disabled", "disabled");
                        this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Mobile blood draw']").classList.add("selected");
    
                        // update Variant ID
                        this.closest(".it-product--form").querySelectorAll(".it-product--form-variants option").forEach((opt, index) => {
                            if(opt.text == "Mobile blood draw / No InnerAge / No Estradiol + Progesterone" || opt.text == "Mobile blood draw / InnerAge" || opt.text == "Mobile blood draw") {
                                this.closest(".it-product--form").querySelector(".it-product--form-variants").selectedIndex = index;
    
                                // update bnpl widget product id
                                document.querySelector(".installment input[name='id']").value = opt.value;
                                document.querySelector('.bnpl__widget input[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));
    
                                // price update
                                productPriceUpdate();
                            }
                        });
    
                    } else {
                        // enable blood draw
                        this.closest(".it-product--form").querySelector(".it-product--form-custom-control[data-option-value='Blood draw in lab']").removeAttribute("disabled");
                    }
                }
            });
        }

        function renderOption() {
            const selected_option = country_select.options[country_select.selectedIndex];

            let get_selected_provinces = selected_option.getAttribute("data-provinces");
            get_selected_provinces = JSON.parse(get_selected_provinces);
            get_selected_provinces = get_selected_provinces.filter((province) => !REMOVE_STATES.includes(province[0]));

            clearOptions(province_select);
            setOptions(province_select, get_selected_provinces);
        }

        function clearOptions(selector) {
            while (selector.firstChild) {
                selector.removeChild(selector.firstChild);
            }
        }

        function setOptions(selector, values) {
            for (let i = 0, count = values.length; i < values.length; i++) {
            const opt = document.createElement("option");
                opt.value = values[i][0];
                opt.innerHTML = values[i][1];
                selector.appendChild(opt);
            }
        }
    }
}

customElements.define('product-location', ProductLocation);

// Product Variant JS

class customSelect extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {

        const parent_form_el = this.closest(".it-product--form");

        this.querySelectorAll(".it-product--form-custom-control").forEach((select) => {
            select.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();

                parent_form_el.querySelectorAll(".it-product--form-custom-control").forEach((el) => el.classList.remove("selected"));
                this.classList.add("selected");

                if(select.dataset.optionValue === "Mobile blood draw") {
                    parent_form_el.querySelectorAll(".it-product--form-variants option").forEach((opt, index) => {
                        if(opt.text == "Mobile blood draw / No InnerAge / No Estradiol + Progesterone" || opt.text == "Mobile blood draw / InnerAge" || opt.text == "Mobile blood draw") {
                            parent_form_el.querySelector(".it-product--form-variants").selectedIndex = index;

                            // update bnpl widget product id
                            document.querySelector(".installment input[name='id']").value = opt.value;
                            document.querySelector('.bnpl__widget input[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));

                            // price update
                            productPriceUpdate();
                        }
                    });
                } else if (select.dataset.optionValue === "Blood draw in lab") {
                    parent_form_el.querySelectorAll(".it-product--form-variants option").forEach((opt, index) => {
                        if(opt.text == "Blood draw in lab / No InnerAge / No Estradiol + Progesterone" || opt.text == "Blood draw in lab / InnerAge" || opt.text == "Blood draw in lab") {
                            parent_form_el.querySelector(".it-product--form-variants").selectedIndex = index;

                            // update bnpl widget product id
                            document.querySelector(".installment input[name='id']").value = opt.value;
                            document.querySelector('.bnpl__widget input[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));

                            // price update
                            productPriceUpdate();
                        }
                    });
                }
            });
        });
    }
}

customElements.define("custom-select", customSelect);

// Product Quantity

class ProductQuantity extends HTMLElement {

    constructor() {
        super();
        this.addEventListener("change", this.quantityHandler);
    }

    quantityHandler(event) {
        if (event.target.value > 8) {
            window.MicroModal.show("quantity-modal");
        }
    }
}

customElements.define("product-quantity", ProductQuantity);


// Product Form JS

class productForm extends HTMLElement {
    constructor() {
        super();   
    }

    connectedCallback() {
        // variables
        const form = this.closest(".it-product--form");
        const add_to_cart_btn = this.querySelector("#it-product--add-to-cart")
        const cart_items = [];

        // form submit event
        form.addEventListener("submit", (event) => {

            // stop default action
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();

            // add loader to add to cart button
            add_to_cart_btn.classList.add("loader");

            // get the formdata
            const form_data = new FormData(form);
            subitForm(form_data);
        });

        function show_login_popup() {
            // show Customer Login Popup
            window.MicroModal.show("customer-login-modal");

            // remove loader to add to cart button
            add_to_cart_btn.classList.remove("loader");

            // build cart and redirect to login

            document.getElementById("customer-log-in").addEventListener("click", function(event) {
                event.target.disabled = true;
                event.target.innerText = "Redirecting...";
                add_to_cart(cart_items, event.target.dataset.url);
            });
        }

        function subitForm(form_data) {
            // check if the product single or variable

            if (form_data.get("has-blood-draw") !== null) {

                // check if the product is exclusive and customer is logged in
                if (window.isCustomerLoggedIn != undefined && form_data.get("properties[Exclusive]") != null) {
                    cart_items.push({
                        id: form_data.get("id"),
                        quantity: form_data.get("quantity"),
                        properties: {
                            "Country": form_data.get("properties[Country]"),
                            "Province": form_data.get("properties[Province]"),
                            "Exclusive": form_data.get("properties[Exclusive]")
                        }
                    });
                    add_to_cart(cart_items);
                }
                
                // check if customer is not logged in but product is exclusive
                else if (form_data.get("properties[Exclusive]") != null) {
                    cart_items.push({
                        id: form_data.get("id"),
                        quantity: form_data.get("quantity"),
                        properties: {
                            "Country": form_data.get("properties[Country]"),
                            "Province": form_data.get("properties[Province]"),
                            "Exclusive": form_data.get("properties[Exclusive]")
                        }
                    });
                    show_login_popup();
                }

                // for all the other products
                else {
                    cart_items.push({
                        id: form_data.get("id"),
                        quantity: form_data.get("quantity"),
                        properties: {
                            "Country": form_data.get("properties[Country]"),
                            "Province": form_data.get("properties[Province]")
                        }
                    });

                    // check if the product is subscription bundle
                    if (form_data.get("sub-id") != null) {
                        cart_items.push({
                            id: form_data.get("sub-id"),
                            selling_plan: form_data.get("sub-selling-plan-id"),
                            quantity: 1
                        })
                    }
                    add_to_cart(cart_items);
                }
            } else {
                form.submit();
            }
        }
    }
}

customElements.define("product-form", productForm);